/** @enum {'maxDiff/show'|'maxDiff/hide'} */
export const MaxDiffEvents = {
    /** @type {'maxDiff/show'} */
    SHOW_MODAL: 'maxDiff/show',
    /** @type {'maxDiff/hide'} */
    HIDE_MODAL: 'maxDiff/hide',
};

/**
 * @param {Object} [options = {}]
 * @param {string|number} options.surveyId - The survey ID
 */
export const showMaxDiffModal = (options = {}) => {
    const event = new CustomEvent(MaxDiffEvents.SHOW_MODAL, {
        detail: options,
    });

    window.dispatchEvent(event);
};

export const hideMaxDiffModal = () => {
    window.dispatchEvent(new CustomEvent(MaxDiffEvents.HIDE_MODAL));
};
